import {UmpireArticle} from '../umpire-article/umpire-article';
import {UmpireImage} from '../umpire-image';
import {UmpirePublicationCategory} from '../umpire-publication-category';

export interface UmpireArticleLink {
  id: string;
  attributes: Omit<UmpireArticle, 'image' | 'publication_categories' | 'components'>;
  relationships: {
    image: Partial<UmpireImage>;
    publication_categories: Partial<UmpirePublicationCategory>;
  };
  type: 'article';
}
